import React, { ReactElement } from "react";
import styles from "./sectionHeader.module.scss";
import classNames from "classnames";

export const SectionHeader = (
  props: SectionHeaderProps = {
    align: "center",
    size: "md",
    badgeTheme: "student",
  },
): ReactElement => {
  const Icon = props.badgeIcon;

  return (
    <div
      className={classNames(styles.base, {
        [styles["verticalPadding"]]: props.verticalPadding !== false,
      })}
    >
      <div
        className={classNames(
          styles.wrapper,
          styles[props.align],
          styles[props.size as any],
          {
            [styles["horizontalPadding"]]: props.horizontalPadding !== false,
          },
        )}
      >
        {(Icon || props.badgeText) && (
          <div
            className={classNames(
              styles.badgeWrapper,
              styles[`theme-${props.badgeTheme}`],
            )}
          >
            {Icon && <Icon className={styles.badgeIcon} />}
            <p className={styles.badgeText}>{props.badgeText}</p>
          </div>
        )}

        <p className={styles.title}>{props.title}</p>
        {props.desc && (
          <div
            className={styles.desc}
            dangerouslySetInnerHTML={{ __html: props.desc }}
          ></div>
        )}
      </div>
    </div>
  );
};

export type SectionHeaderProps = {
  badgeIcon?: React.ElementType;
  badgeText?: string;
  title?: string;
  desc?: string;
  badgeTheme?: "student" | "teacher";
  align?: "left" | "center";
  size?: "xs" | "sm" | "md" | null;
  verticalPadding?: boolean;
  horizontalPadding?: boolean;
};
